import { render, staticRenderFns } from "./ztAvatar.vue?vue&type=template&id=39293978"
import script from "./ztAvatar.vue?vue&type=script&lang=js"
export * from "./ztAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports